const CALLCENTER_QUERY = 'callcenter';

function getQueryParam(param) {
  const query = window.location.search;

  if (!query) {
    return;
  }
  const queryParams = query.substring(1);
  const map = new Map();
  queryParams.split('&').forEach(param => {
    const pair = param.split('=');
    map.set(pair[0], pair[1]);
  });

  return map.get(param);
}

function isFromCallcenter() {
  const param = getQueryParam(CALLCENTER_QUERY);
  return param !== undefined && 'true' === param.toLowerCase();
}

module.exports = { isFromCallcenter, getQueryParam };



// WEBPACK FOOTER //
// ./src/services/queryService/QueryService.js